import React from 'react';
import ReactDOM from 'react-dom';
import { ConfigProvider } from 'antd';
import Routes from './routes';
import colors from './shared/theme/colors.json';
import applyCssVariables from './shared/theme/applyCssVariables';
import './global.css';

applyCssVariables(colors);

// antd 5 ignora as variáveis Less do craco.config.js; o tema efetivo vem do ConfigProvider.
ReactDOM.render(
  <ConfigProvider theme={{ token: { colorPrimary: colors.primary } }}>
    <Routes />
  </ConfigProvider>,
  document.getElementById('root')
);
